import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import 'toastr/build/toastr.css';
import 'ScrollBar.css';
import { AuthProvider } from 'AuthContext';
import { ConfigProvider, App as AntApp } from "antd";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
        <BrowserRouter>
            <ConfigProvider>
                <AuthProvider>
                <AntApp> {/* Bọc toàn bộ app trong Ant Design App */}
                    <App />
                </AntApp>
                </AuthProvider>
            </ConfigProvider>
        </BrowserRouter>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
